<template>
	<header class="header-wrap">
		<div class="container">
			<!-- desktop nav start -->
			<div class="header desktop-nav">
				<div class="logo-container">
					<router-link to="/" class="logo">
		    			<img alt="commaful-logo" src="../../assets/images/logo.png" />
					</router-link>
				</div>
				<!-- start: search & user box -->
				<div class="header-right">

					<form action="#" class="search nav-form">
						<div class="input-group">
							<button class="header-search-submit" type="submit"><img alt="commaful-logo" src="../../assets/icon/search-icon.svg" /></button>
							<input type="text" class="header-search" name="q" id="q" placeholder="Search your story here">
						</div>
					</form>

					<ul class="header-right-nav">

		                <base-dropdown class="nav-link dropdown-menu-center message-notify">
		                    <div class="profile d-flex align-items-center" slot="title">
								<img alt="commaful-logo" src="../../assets/icon/bell.svg" />
		                    </div>

		                    <template>
		                    	<div class="dropdown-heading d-flex space-between">
		                    		<h5>Notificatons</h5>
		                    		<span>View all</span>
		                    	</div>
		                        <router-link to="/notificatons/1" class="dropdown-item ">
		                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod...</p>
		                        </router-link>
		                        <router-link to="/notificatons/2" class="dropdown-item ">
		                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod...</p>
		                        </router-link>
		                        <router-link to="/notificatons/3" class="dropdown-item ">
		                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod...</p>
		                        </router-link>
		                    </template>
		                </base-dropdown>

		                <base-dropdown class="nav-link  dropdown-menu-center message-notify">
		                    <div class="profile d-flex align-items-center" slot="title">
		                        <img alt="commaful-logo" src="../../assets/icon/message-square.svg" />
		                        <span class="badge">2</span>
		                    </div>

		                    <template>
		                    	<div class="dropdown-heading d-flex space-between">
		                    		
			                        <!-- <router-link to="/empty-inbox" class="header-inbox">
			                            Inbox
			                        </router-link> -->
			                        <router-link to="/inbox" class="header-inbox">
			                            Inbox
			                        </router-link>
		                    		<span>Mark All as Read</span>
		                    	</div>
		                        <router-link to="/chat-details/1" class="dropdown-item ">
		                            <img alt="profile-img" src="../../assets/images/avatar.png" />
		                            <p>Lorem ipsum dolor sit amet, consectetur...</p>
		                        </router-link>
		                        <router-link to="/chat-details/1" class="dropdown-item ">
		                            <img alt="profile-img" src="../../assets/images/avatar.png" />
		                            <p>Lorem ipsum dolor sit amet, consectetur...</p>
		                        </router-link>
		                        <router-link to="/chat-details/1" class="dropdown-item ">
		                            <img alt="profile-img" src="../../assets/images/avatar.png" />
		                            <p>Lorem ipsum dolor sit amet, consectetur...</p>
		                        </router-link>
		                    </template>
		                </base-dropdown>

		                <base-dropdown class="nav-link dropdown-menu-right">
		                    <div class="profile d-flex align-items-center" slot="title">
		                        <span class="avatar rounded-circle">
		                         <img alt="profile-img" src="../../assets/images/avatar.png" />
		                        </span>
		                        <div class="profile-nav">
									<span class="avatar-name">Dara Adhelia</span>
									<img alt="commaful-sort-down" src="../../assets/icon/sort-down.svg" />
		                        </div>
		                    </div>

		                    <template>
		                    	<router-link :to="{ name: 'profile', params: { name: 'shuvosd' }}" class="dropdown-item">
		                            <i class="fas fa-user"></i>
		                            <span>My profile</span>
		                        </router-link>
		                        <router-link to="/" class="dropdown-item">
		                        	<i class="fas fa-cog"></i>
		                            <span>Settings</span>
		                        </router-link>
		                        <router-link to="/" class="dropdown-item">
		                            <i class="fas fa-calendar-alt"></i>
		                            <span>Activity</span>
		                        </router-link>
		                        <router-link to="/" class="dropdown-item">
		                            <i class="fas fa-question-circle"></i>
		                            <span>Support</span>
		                        </router-link>
		                        <div class="dropdown-divider"></div>
		                        <router-link to="/" class="dropdown-item">
		                            <i class="fas fa-running"></i>
		                            <span>Logout</span>
		                        </router-link>
		                    </template>
		                </base-dropdown>
					</ul>
				</div>
				<!-- end: search & user box -->
			</div>
			<!-- desktop nav end -->

			<!-- mobile nav start -->
			<div class="header mobile-nav">
				<div class="togglgeBtn" :class="{'menu-open':isToggleOpen}">
					<div class="mblBtn" @click="toggleMenu">
						<img src="../../assets/icon/hamburger.svg" alt="hamburger" class="btnOpen">
						<i class="fas fa-times btnClose"></i>
					</div>

					<ul class="mobileNav header-right-nav">

		                <base-dropdown class="nav-link dropdown-menu-center message-notify">
		                    <div class="profile d-flex align-items-center" slot="title">
								<img alt="commaful-logo" src="../../assets/icon/bell.svg" />
		                    </div>

		                    <template>
		                    	<div class="dropdown-heading d-flex space-between">
		                    		<h5>Notificatons</h5>
		                    		<span>View all</span>
		                    	</div>
		                        <router-link to="/notificatons/1" class="dropdown-item ">
		                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod...</p>
		                        </router-link>
		                        <router-link to="/notificatons/2" class="dropdown-item ">
		                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod...</p>
		                        </router-link>
		                        <router-link to="/notificatons/3" class="dropdown-item ">
		                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod...</p>
		                        </router-link>
		                    </template>
		                </base-dropdown>

		                <base-dropdown class="nav-link  dropdown-menu-center message-notify">
		                    <div class="profile d-flex align-items-center" slot="title">
		                        <img alt="commaful-logo" src="../../assets/icon/message-square.svg" />
		                        <span class="badge">2</span>
		                    </div>

		                    <template>
		                    	<div class="dropdown-heading d-flex space-between">
			                        <router-link to="/inbox" class="header-inbox">
			                            Inbox
			                        </router-link>
		                    		<span>Mark All as Read</span>
		                    	</div>
		                        <router-link to="/chat-details/1" class="dropdown-item ">
		                            <img alt="profile-img" src="../../assets/images/avatar.png" />
		                            <p>Lorem ipsum dolor sit amet, consectetur...</p>
		                        </router-link>
		                        <router-link to="/chat-details/2" class="dropdown-item ">
		                            <img alt="profile-img" src="../../assets/images/avatar.png" />
		                            <p>Lorem ipsum dolor sit amet, consectetur...</p>
		                        </router-link>
		                        <router-link to="/chat-details/3" class="dropdown-item ">
		                            <img alt="profile-img" src="../../assets/images/avatar.png" />
		                            <p>Lorem ipsum dolor sit amet, consectetur...</p>
		                        </router-link>
		                    </template>
		                </base-dropdown>

		                <base-dropdown class="nav-link dropdown-menu-right">
		                    <div class="profile d-flex align-items-center" slot="title">
		                        <span class="avatar rounded-circle">
		                         <img alt="profile-img" src="../../assets/images/avatar.png" />
		                        </span>
		                        <div class="profile-nav">
									<span class="avatar-name">Dara Adhelia</span>
									<img alt="commaful-sort-down" src="../../assets/icon/sort-down.svg" />
		                        </div>
		                    </div>

		                    <template>
		                        <router-link :to="{ name: 'profile', params: { name: 'shuvosd' }}" class="dropdown-item">
		                            <i class="fas fa-user"></i>
		                            <span>My profile</span>
		                        </router-link>
		                        <router-link to="/" class="dropdown-item">
		                        	<i class="fas fa-cog"></i>
		                            <span>Settings</span>
		                        </router-link>
		                        <router-link to="/" class="dropdown-item">
		                            <i class="fas fa-calendar-alt"></i>
		                            <span>Activity</span>
		                        </router-link>
		                        <router-link to="/" class="dropdown-item">
		                            <i class="fas fa-question-circle"></i>
		                            <span>Support</span>
		                        </router-link>
		                        <div class="dropdown-divider"></div>
		                        <router-link to="/" class="dropdown-item">
		                            <i class="fas fa-running"></i>
		                            <span>Logout</span>
		                        </router-link>
		                    </template>
		                </base-dropdown>
		                
					</ul>
				</div>
				<!-- /. toggleBtn -->

				<div class="logo-container">
					<router-link to="/" class="logo">
		    			<img alt="commaful-logo" src="../../assets/images/logo.png" />
					</router-link>
				</div>
				<!-- /. logo-container -->

				<div class="searchArea">
					<img src="../../assets/icon/blue-search.svg" alt="blue-search" @click="searchExp()">
					<form @submit.prevent="searchSubmit" class="headerSearch" :class="{'searchInput':searchBarExp}">
						<input type="text" placeholder="Search..." v-model="searchVal">
						<button type="submit" >
							<img src="../../assets/icon/blue-search.svg" alt="blue-search">
						</button>
						<div class="closeSearch" @click="closeSearch">
							<i class="fas fa-times-circle"></i>
						</div>
					</form>
				</div>
				<!-- /. searchArea -->
			</div>
			<!-- mobile nav end -->
		</div>
	</header>
</template>



<script>
	export default {
		data(){
			return{
        		searchBarExp:false,
        		isToggleOpen:false,
        		searchVal:'',

			}
		},

		methods: {
			searchExp(){
				this.searchBarExp=!this.searchBarExp;
			},
			toggleMenu(){
				this.isToggleOpen=!this.isToggleOpen;
			},

			searchSubmit(){
				if(this.searchVal) {
					console.log(this.searchVal);
				} 
			},
			closeSearch(){
				this.searchBarExp=false;
			},

		}
	}
</script>


<style>
	@import '../../assets/css/header.css';
	.header-inbox{
		color: #313131;
	}
	
</style>